<template>
  <div class="row mt-5">
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label class="required">{{ $t('trainingWeeks') }}</label>
        <select
          class="form-control custom-select"
          name="tested_exercises"
          id="tested_exercises"
          @change="buscarTreinoSemana"
          v-model="state.selectedWeek"
        >
          <option value="">{{ $t('selectTrainingWeek') }}</option>
          <option v-for="(item, index) in state.semanas" :key="index" :value="item.id">
            {{ $t('week') }} {{ index + 1 }} | {{ $filters.datePtbr(item.initial_date) }} {{ $t('to') }}
            {{ $filters.datePtbr(item.final_date) }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-12">
      <ul class="nav nav-tabs" id="myTab-semana-elaborada" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          v-for="(item, index) in state.daysOfWeek"
          :key="index"
        >
          <button
            class="nav-link"
            :id="item.day + '-tab'"
            data-bs-toggle="tab"
            :data-bs-target="'#' + item.day"
            type="button"
            role="tab"
            :aria-controls="item.day"
            aria-selected="true"
          >
            {{ $filters.nameDayPortuguese(item.day) }}
          </button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade"
          v-for="(item, index) in state.daysOfWeek"
          :key="index"
          :id="item.day"
          role="tabpanel"
          :aria-labelledby="item.day + '-tab'"
        >
          <tabela-exercicios-elaborados
            :exerciciosProp="item.exercises"
            :exerciciosTestadosProp="state.testedExercises"
            :isEditMode="false"
          ></tabela-exercicios-elaborados>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import planosTreinoRepository from '../../../../services/api/planosTreinoRepository'
import testesCargaRepository from '../../../../services/api/testesCargaRepository'
import { reactive, onMounted, ref, inject, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import TabelaExerciciosElaborados from './TabelaExerciciosElaborados.vue'
export default {
  components: {
    TabelaExerciciosElaborados,
  },
  props: {
    testedExercises: {
      type: Array,
      default: new Array(),
    },
    planoTreinoId: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    onMounted(() => {
      state.planoTreinoId = props.planoTreinoId
      //state.testedExercises = props.testedExercises
      if (parseInt(state.planoTreinoId) > 0) {
        buscarPlanoDetreinoSemanas()
        buscarExerciciosTestados()
      }
    })

    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()

    const state = reactive({
      semanas: [],
      planoTreinoId: 0,
      selectedWeek: '',
      weekTraining: [],
      daysOfWeek: [],
      testedExercises: [],
    })

    const buscarExerciciosTestados = async () => {
      try {
        store.commit('SET_SPLASH_SCREEN', true)
        let response = await testesCargaRepository.ExerciciosByTesteCargaIdGet(state.planoTreinoId)
        store.commit('SET_SPLASH_SCREEN', false)
        if (response.data.success) {
          state.testedExercises = response.data.data
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        swal({
          icon: 'error',
          title: 'Erro ao listar exercicios testados!',
          text: error.message,
        })
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const buscarPlanoDetreinoSemanas = async () => {
      try {
        store.commit('SET_SPLASH_SCREEN', true)
        let response = await planosTreinoRepository.SemanasGetByPlanosTreinoId(state.planoTreinoId)
        state.semanas = []
        if (response.data.success) {
          state.semanas = response.data.data.map((item) => {
            item['copiar'] = false
            return item
          })
        }

        store.commit('SET_SPLASH_SCREEN', false)
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        swal({
          icon: 'error',
          title: 'Erro ao listar semanas do plano de treino!',
          text: error.message,
        })
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const buscarTreinoSemana = async () => {
      if (!state.selectedWeek || state.selectedWeek === '') {
        state.daysOfWeek = []
        return
      }

      try {
        store.commit("SET_SPLASH_SCREEN", true)
        let response = await planosTreinoRepository.PlanoTreinoElaboradoBySemanaIdGet(state.selectedWeek)
        if (response.data.success) {
          state.weekTraining = []
          state.weekTraining = response.data.data
          state.daysOfWeek = []

          for (const [key, value] of Object.entries(response.data.data)) {
            let exercises = value.map(exercise => {
              // Proteção: buscar exercício testado, se não encontrar, usar valores padrão
              let item = state.testedExercises.find(x => x.exercise_id == exercise.exercise_id)

              if (item) {
                exercise['max_load_test'] = item.max_load_test
              } else {
                exercise['max_load_test'] = 0
              }

              if(!exercise.series || exercise.series.length == 0) {
                exercise.series = [{
                  repetition: '',
                  load: '',
                  perc_load: '',
                  series: '',
                }]
              }
              return exercise
            })

            state.daysOfWeek.push({
              day: key,
              exercises: exercises
            })
          }

          console.log('Dias da semana carregados:', state.daysOfWeek)

          // Ativar a primeira aba automaticamente após carregar
          setTimeout(() => {
            if (state.daysOfWeek.length > 0) {
              const firstTab = document.querySelector('#myTab-semana-elaborada .nav-link:first-child')
              if (firstTab) {
                firstTab.classList.add('active')
                const targetId = firstTab.getAttribute('data-bs-target')
                const targetPane = document.querySelector(targetId)
                if (targetPane) {
                  targetPane.classList.add('show', 'active')
                }
              }
            }
          }, 100)
        }
      } catch (error) {
        console.error('Erro ao buscar treino da semana:', error)
        swal({
          icon: 'error',
          title: 'Erro ao buscar treino da semana!',
          text: error.message,
        })
        store.commit("SET_SPLASH_SCREEN", false)
      } finally {
        store.commit("SET_SPLASH_SCREEN", false)
      }
    }

    return {
      state,
      buscarTreinoSemana,
    }
  },
}
</script>

<style scoped>
/* Garantir que as abas sejam visíveis */
.nav-tabs .nav-link {
  color: #495057 !important;
  opacity: 1 !important;
}

.nav-tabs .nav-link.active {
  color: #495057 !important;
  font-weight: bold !important;
}

/* Garantir que o texto apareça em campos readonly/disabled */
.form-control[readonly],
.form-control[disabled],
span.form-control,
.form-control-plaintext {
  color: #495057 !important;
  background-color: #e9ecef !important;
  opacity: 1 !important;
}

/* Melhorar contraste para melhor legibilidade */
.form-control,
.custom-select {
  color: #212529 !important;
}

/* Garantir visibilidade dos options no select */
select option {
  color: #212529 !important;
  background-color: #ffffff !important;
}
</style>
